
import { useState, useEffect } from "react"
import "../Css_files/FeaturedSlider.css"
import img1 from "../Images/team 1.jpg"
import img2 from "../Images/Team-members.jpeg"
import img3 from "../Images/slide3.jpeg"
import img4 from "../Images/slide4.jpeg"
const FeaturedSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  const featuredAchievements = [
    {
      id: 1,
      title: "Best Tech Innovation Award 2024",
      description:
        "Recognized for groundbreaking AI solutions that transformed client operations and delivered exceptional ROI.",
      image: img1,
      date: "03/15/2024",
      category: "Awards",
    },
    {
      id: 2,
      title: "Global Partnership Milestone",
      description:
        "Successfully established strategic partnerships with 50+ international clients across 15 countries.",
      image: img2,
      date: "01/20/2024",
      category: "Partnerships",
    },
    {
      id: 3,
      title: "Team Excellence Recognition",
      description: "Our dedicated team of 200+ professionals achieved 99.8% client satisfaction rating this quarter.",
      image: img3,
      date: "02/10/2024",
      category: "Team",
    },
    {
      id: 4,
      title: "Sustainability Initiative Launch",
      description:
        "Launched comprehensive green technology program reducing carbon footprint by 40% across all operations.",
      image: img4,
      date: "04/05/2024",
      category: "Sustainability",
    },
  ]

  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredAchievements.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [isAutoPlaying, featuredAchievements.length])

  const goToSlide = (index) => {
    setCurrentSlide(index)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredAchievements.length)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredAchievements.length) % featuredAchievements.length)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  const ChevronLeft = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15,18 9,12 15,6"></polyline>
    </svg>
  )

  const ChevronRight = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
  )

  const PlayIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="5,3 19,12 5,21"></polygon>
    </svg>
  )

  const PauseIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="4" width="4" height="16"></rect>
      <rect x="14" y="4" width="4" height="16"></rect>
    </svg>
  )

  return (
    <div className="featured-slider">
      {/* Slides Container */}
      <div className="slides-container" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {featuredAchievements.map((achievement, index) => (
          <div key={achievement.id} className="slide">
            <div className="slide-image-container">
              <img src={achievement.image || "/placeholder.svg"} alt={achievement.title} className="slide-image" />
              <div className="slide-overlay"></div>
            </div>

            {/* Content Overlay */}
            <div className="slide-content">
              <div className="slide-content-inner">
                <div className="slide-meta">
                  <span className="slide-category">{achievement.category}</span>
                  <span className="slide-date">{achievement.date}</span>
                </div>
                <h2 className="slide-title">{achievement.title}</h2>
                <p className="slide-description">{achievement.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button onClick={prevSlide} className="nav-button nav-button-prev" aria-label="Previous slide">
        <ChevronLeft />
      </button>

      <button onClick={nextSlide} className="nav-button nav-button-next" aria-label="Next slide">
        <ChevronRight />
      </button>

      {/* Slide Indicators */}
      <div className="slide-indicators">
        {featuredAchievements.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`indicator-button ${index === currentSlide ? "active" : ""}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Auto-play indicator */}
      <div className="autoplay-control">
        <button
          onClick={() => setIsAutoPlaying(!isAutoPlaying)}
          aria-label={isAutoPlaying ? "Pause slideshow" : "Play slideshow"}
        >
          {isAutoPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
      </div>
    </div>
  )
}

export default FeaturedSlider
